import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const INSPECTION_ENDPOINTS = {
  V1: createEndpoints('v1', {
    INSPECTION_PURPOSES: '/inspection-purposes/',
    STATUS: '/status/',
    INSPECTION_PERIODS: '/inspection-periods/',
  }),
} as const;
